import { Button, Form, Modal, Typography } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import approveIcon from "../../../../Assets/acceptConsent.png";
import { CloseIcon } from "../../../../Assets/icons";
import rejectIcon from "../../../../Assets/rejectConsentIcon.png";
import { translation } from "../../../../i18n/translationConstant";
import { UserLoginSuccessResponse } from "../../../../Models/Response/Authentication/Otp";
import {
  sendOtp,
  verifyOtp,
} from "../../../../Services/AuthenticationServices/AuthenticationServices";
import { LoginSignupFormType } from "../../../../Utils/Constants/loginSignupFormTypes";
import ForgotPassword from "../../../Authentication/Components/ForgotPassword";
import OTPInputComponent from "../../../Common/Components/OTPModal";
import PinInputComponent from "../../../Common/Components/PinInput";
import UserIdentification from "../../../Identifiers/UserIdentification";
import "./index.css";

interface IConsentStatusApprovalComponentProps {
  isAuthTypeSelectionModalVisible: boolean;
  onCloseAuthTypeSelectionModal: () => void;
  onAuthTypeRadioSelectionChange: (event: number) => void;
  onAuthTypeModalSubmit: () => void;
  selectedAuthType: number;
  verifyOTPAuthType: (otp: string) => void;
  isAuthTypeOTPModalVisible: boolean;
  onCloseOTPModal: () => void;
  typeOfModal: string;
  pinModalVisible: boolean;
}

const ConsentStatusApprovalComponent: React.FC<
  IConsentStatusApprovalComponentProps
> = ({
  selectedAuthType,
  isAuthTypeOTPModalVisible,
  isAuthTypeSelectionModalVisible: isAuthTypeSelectionModalOpen,
  onCloseOTPModal,
  onCloseAuthTypeSelectionModal,
  typeOfModal,
  onAuthTypeRadioSelectionChange,
  onAuthTypeModalSubmit,
  verifyOTPAuthType,
  pinModalVisible,
}) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [token, setToken] = useState("");
    const [otpUniqueID, setOTPUniqueId] = useState("");
    const [mobile, setmobile] = useState("");
    const [visible, setVisibility] = useState(false);
    const [isAddIdentifierVerification, setVerification] = useState(false);

    const onCancel = () => {
      setVisibility(false);
      setVerification(false);
    };

    const onIdentifierEntered = (iNumber: any) => {
      setmobile(iNumber.value);
      sendOtp({ phoneNumber: iNumber.value })
        .then((res) => res.data)
        .then((res) => {
          setOTPUniqueId(res);

          setVerification(true);
        });
    };

    const onOTPSubmit = (otp: string, identifierNumber: any) => {
      setToken("");

      verifyOtp({
        phone_number: mobile,
        grant_type: "password",
        code: otp,
        otpUniqueID,
      })
        .then((res) => res.data)
        .then((res: UserLoginSuccessResponse) => {
          form.resetFields();
          setVisibility(false);
          setVerification(false);
          setToken(res.access_token);
        });
    };

    const verifyOtpAuth = (otp: string) => {
      verifyOTPAuthType(otp);
    };

    const getTypeOfModal = () => {
      if (
        typeOfModal ===
        "FAILED"
      ) {
        return "Reject";
      }

      return typeOfModal ===
        "READY"
        ? "Accept"
        : typeOfModal === "ACTIVE"
          ? "Reactivate"
          : typeOfModal;
    };

    const authTypeChange = () => {
      onAuthTypeRadioSelectionChange(selectedAuthType === 0 ? 1 : 0);
    };

    const pinSubmit = () => {
      verifyOtpAuth(form.getFieldValue(LoginSignupFormType.pin));
    };

    return (
      <>
        {token && <ForgotPassword token={token} />}
        <UserIdentification
          handleCancel={onCancel}
          identifierEntered={onIdentifierEntered}
          isAddIdentifierVerification={isAddIdentifierVerification}
          onOTPSubmit={onOTPSubmit}
          visible={visible}
          label={t("Enter Mobile Number")}
          multipleIdentifiers={false}
          isForgotPassword={true}
          mobileNumber={mobile}
          entityIdentifiers={[]}
        />
        <OTPInputComponent
          isOpen={isAuthTypeOTPModalVisible}
          onCancel={onCloseOTPModal}
          onOtpSubmit={verifyOtpAuth}
          okText={getTypeOfModal()}
          title={t(
            getTypeOfModal() +
            `${typeOfModal !== "Unlink Account" ? " Consent" : ""}`
          )}
          onResend={onAuthTypeModalSubmit}
        />

        <OTPInputComponent
          isOpen={pinModalVisible}
          isPinModal={true}
          onCancel={onCloseOTPModal}
          onOtpSubmit={pinSubmit}
          okText={"Verify"}
          title={t(
            getTypeOfModal() +
            `${typeOfModal !== "Unlink Account" ? " Consent" : ""}`
          )}
          isOtpInputVisible={true}
        >
          <Form
            form={form}
            className="form"
            name="basic"
            autoComplete="off"
            scrollToFirstError={true}
          >
            <PinInputComponent className="pinInput" />
          </Form>
          <Button
            type="text"
            className="forgotPinButtonModal"
            onClick={() => setVisibility(true)}
          >
            {t(translation.lblForgotPassword)}
          </Button>
        </OTPInputComponent>

        <Modal
          closeIcon={<CloseIcon />}
          className="footerRoot"
          visible={isAuthTypeSelectionModalOpen}
          okText={t(translation.lblConfirm)}
          cancelButtonProps={{ hidden: true }}
          okButtonProps={{ hidden: true }}
          onCancel={onCloseAuthTypeSelectionModal}
          footer={null}
        >
          <div className="flexCommonCss">
            <Typography.Text className="typoOTP">
              {t(
                getTypeOfModal() +
                `${typeOfModal !== "Unlink Account" ? " Consent" : ""}`
              )}
            </Typography.Text>
            {getTypeOfModal() === "APPROVE" ? (
              <img
                src={approveIcon}
                width={130}
                height={130}
                className="marginTop40"
                alt=""
              />
            ) : (
              <img
                src={rejectIcon}
                width={130}
                height={130}
                className="marginTop40"
                alt=""
              />
            )}
            <Typography.Text
              className="authTypeSelectButton"
              onClick={authTypeChange}
            >
              {selectedAuthType === 0
                ? t(translation.lblOtpValidationRequest)
                : t(translation.lblPinValidationRequest)}
            </Typography.Text>
            <div className="modalButtonGroup">
              <Button
                className="commonButtonBackground secondaryButton width40Pmargintop0"
                onClick={onCloseAuthTypeSelectionModal}
              >
                {t(translation.lblCancel)}
              </Button>

              <Button
                className="commonButtonBackground primaryButton linkAccountNoAccounts primaryButtonWidth"
                onClick={onAuthTypeModalSubmit}
              >
                {selectedAuthType === 0
                  ? t(translation.lblContinueWithPin)
                  : t(translation.lblContinueWithOtp)}
              </Button>
            </div>
          </div>
        </Modal>
      </>
    );
  };

export default ConsentStatusApprovalComponent;
